import {useLazyQuery} from "@apollo/client/react";
import {CtrSousTypeCaracteristiques, CtrStaticTables, Query} from "../graphql/generated/graphql-main.tsx";
import {gqlTemplates} from "../utils/gql-client.ts";
import {coreActions} from "../store/slice-core";
import {useXDispatch, useXSelector} from "../store/hooks.ts";
import {useWpContext} from "../components/context/WordPressProvider.tsx";
import {useEffect} from "react";
import {CoreStateType} from "../store/slice-core/types.ts";
import {DocumentNode} from "@apollo/client";

const set = coreActions.$setSousTypeCaracteristiques;
// data type in Redux Store core slice
const dtype: keyof CoreStateType = CtrStaticTables.SousTypeCaracteristiques;
// GraphQL document node to query for the data type
const gnode: DocumentNode = gqlTemplates.sousTypesCaracteristiques;
// GraphQL mutation result data key
const gkey: keyof Query = "ctrSousTypesCaracteristiques";

export default function useCtrSousTypeCarac<T extends CtrSousTypeCaracteristiques>() {
    const dispatch = useXDispatch();
    const $entries = useXSelector(s => s.core[dtype] as T[]);

    const [fetch, {loading}] = useLazyQuery<Query>(gnode, {fetchPolicy: "cache-and-network"});
    const load = async () => {
        const {data} = await fetch();
        if (data?.[gkey] == null) return;
        dispatch(set(data?.[gkey] as T[]));
    }

    useEffect(() => {
        if ($entries.length > 0) return;
        load();
    }, [$entries]);

    return {
        $entries: $entries,
        loading: loading,
    }
}